import { Chip } from '../primitives/chip.js'
import type { ChipProps } from '../primitives/chip.js'
import { getColorCSS } from '../color/color.js'
import { hashColorName } from '../color/hash-color.js'
import { readableTextOn } from '../theme/color-math.js'

export interface TagProps extends ChipProps {
  label: string
  variant?: 'filled' | 'outlined'
}

/**
 * A tag keeps the colour its label hashes to; its text is whichever of white or black reads on that colour. White on
 * most of Material's 500 shades is under 4.5:1 (Joni's phone audit, #3110 item 6).
 */
export const Tag = ({ label, style, ...restProps }: TagProps) => {
  const bgColor = getColorCSS(hashColorName(label))
  return (
    <Chip
      label={label}
      style={{
        marginLeft: 0,
        backgroundColor: bgColor,
        color: readableTextOn(bgColor),
        ...style,
      }}
      {...restProps}
    />
  )
}
